import { render } from "./myQuestion.vue?vue&type=template&id=39e1199b&scoped=true"
import script from "./myQuestion.vue?vue&type=script&lang=js"
export * from "./myQuestion.vue?vue&type=script&lang=js"

import "./myQuestion.vue?vue&type=style&index=0&id=39e1199b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e1199b"]])

export default __exports__